<template>
  <div class="d-flex justify-start ma-0 pa-0 ga-5" style="min-width:95vw; max-width:95vw">
    <v-card class="w-33 elevation-5 title-list">

      <v-expansion-panels>
        <v-expansion-panel :title="'Client ' + c" v-for="(c) in [1,2]">
            <v-expansion-panel-text>

              <v-list lines="three">
                <v-list-item 
                  v-for="(quiz, i) in quizList.filter(q => q.clientId === c)"
                  :key="i"
                  :value="quiz"
                  color="primary" 
                  class="mx-3 mb-3 elevation-5 rounded"
                  @click="loadQuiz(quiz)"
                >
                  <v-btn icon="mdi-download" density="compact"  @click="downloadFile(quiz.id)" class="ma-2"></v-btn>
                  <v-btn icon="mdi-eye-outline" density="compact"  @click="preview(quiz)" class="ma-2"></v-btn> 
                  <!-- -->
                  
                  <v-spacer></v-spacer>
                  <v-chip density="compact" class="me-1" color="primary">Client {{ quiz.clientId}}</v-chip>
                  <v-chip density="compact" v-if="quiz.isActive === true" color="green">Active</v-chip>
                  <v-chip density="compact" v-if="quiz.isActive === false" color="red">InActive</v-chip>
                  <v-list-item-title>
                    {{ quiz.title }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-high-emphasis">
                    {{ quiz.subtitle }}
                  </v-list-item-subtitle>
                </v-list-item>                
              </v-list>

            </v-expansion-panel-text>
        </v-expansion-panel>
      </v-expansion-panels>      
    </v-card>

    <v-card v-if="selectedQuiz !== null" class="flex-grow-1 w-50 elevation-5 pa-5">
      <v-switch
        v-model="selectedQuiz.isActive"
        color="primary"
        label="Activate"
      ></v-switch>
      <v-sheet class="px-2 mx-2 mb-2">
        <v-date-input
          v-model="selectedQuiz.masterStartDate"
          label="Start Date"
          variant="underlined"
          prepend-icon=""
          persistent-placeholder
          density="compact"
          append-inner-icon="mdi-pencil"
          readonly      
        ></v-date-input> 
      </v-sheet>
      <v-sheet class="px-2 mx-2 mb-2">
        <v-date-input
          v-model="selectedQuiz.masterEndDate"
          label="End Date"
          variant="underlined"
          prepend-icon=""
          persistent-placeholder
          density="compact"
          append-inner-icon="mdi-pencil"
          readonly      
        ></v-date-input> 
      </v-sheet>

      <div class="text-caption">Eligible Points Per Answer is set to&nbsp;&nbsp;<span class="text-primary font-weight-bold text-h6">{{ selectedQuiz.eligiblePointsPerAnswer }}</span></div>
      <v-slider
        v-model="selectedQuiz.eligiblePointsPerAnswer"
        color="primary"
        :min="0"
        :max="10"
        show-ticks
        thumb-label
        step="1"
        tick-size="5"
      ></v-slider>      

      <div class="text-caption">Max Attempts is set to&nbsp;&nbsp;<span class="text-primary font-weight-bold text-h6">{{ selectedQuiz.maxAttempts }}</span></div>
      <v-slider
        v-model="selectedQuiz.maxAttempts"
        color="primary"
        :min="1"
        :max="3"
        show-ticks
        thumb-label
        step="1"
        tick-size="5"
      ></v-slider>

      <v-expansion-panels>

        <v-expansion-panel title="Title">
          <v-expansion-panel-text>
            <div v-for="(translation, i) in selectedQuiz.translation">
              <v-text-field 
                v-model="translation.title"
                class="ma-2" 
                density="compact" 
                variant="outlined" 
                hide-details 
                :label="translation.language"
              ></v-text-field>
            </div>
          </v-expansion-panel-text>
        </v-expansion-panel>

        <v-expansion-panel title="Subtitle">
          <v-expansion-panel-text>
            <div v-for="(translation, i) in selectedQuiz.translation">
              <v-text-field 
                v-model="translation.subtitle"
                class="ma-2" 
                density="compact" 
                variant="outlined" 
                hide-details 
                :label="translation.language"
              ></v-text-field>
            </div>
          </v-expansion-panel-text>
        </v-expansion-panel>

      </v-expansion-panels>

    </v-card>

    <v-card v-if="selectedQuiz !== null" class="flex-grow-1 w-100 elevation-5">
      <div class="ma-2">
        <v-btn icon="mdi-cloud-arrow-up-outline" @click="saveMasterQuiz"></v-btn>
      </div>
      <v-expansion-panels>
        <div class="d-flex flex-column w-100 ma-1">
          <div v-for="(question, i) in selectedQuiz.questions" class="ma-1 elevation-5">

            <v-expansion-panel :title="'Question ' + (i + 1)">
              <v-expansion-panel-text>
                <v-expansion-panels variant="inset">
                  <div v-for="(translation, i) in question.translation" class="d-flex flex-column w-100 ma-1">
                    <v-expansion-panel :title="translation.language" class="mx-5">
                      <v-expansion-panel-text>
                        <v-text-field 
                          v-model="translation.question"
                          class="ma-5" 
                          density="compact" 
                          variant="outlined" 
                          hide-details 
                          label="Question"
                        ></v-text-field>
                        <div v-for="(option, o) in translation.options" :key="o" class="d-flex flex-column w-100 ma-1">
                          <div class="d-flex flex-row ms-2">
                            <v-switch v-if="translation.language === 'English' && !(!option || option.trim() === '')"
                              v-model="question.answers"
                              :value="o"
                              color="primary"
                              hide-details
                              false-icon="mdi-close"
                              true-icon="mdi-check"
                              class="me-1"
                              @click="updateAnswersList(question.answers, o, $event)"
                            >
                          </v-switch>
                            <v-text-field 
                              v-model="translation.options[o]"
                              class="me-5 my-1" 
                              density="compact" 
                              variant="outlined" 
                              hide-details 
                              :label="'Option ' + (o+1)"
                            ></v-text-field> 
                          </div>                          
                        </div>
                      </v-expansion-panel-text>
                    </v-expansion-panel>
                  </div>  
                </v-expansion-panels>
              </v-expansion-panel-text>
            </v-expansion-panel>

          </div>
        </div>

      </v-expansion-panels>
    </v-card>
  </div>

  <v-dialog v-model="showPreview" width="500" scrollable>
    <v-card>
        <v-toolbar>
            <v-toolbar-title>Preview Quiz: {{ previewTitle }}</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pa-4">
          <v-select 
            :items="previewLanguages" 
            v-model="previewLanguage" 
            label="Select Language" 
            item-title="previewLanguage" 
            item-value="previewLanguage"
            variant="outlined" 
            density="comfortable">
          </v-select>
        </v-card-text>
        <v-card-actions class="border-t-thin">
            <v-btn @click="loadPreview()" width="100">Load</v-btn>
            <v-btn @click="showPreview = false" width="100">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

</template>

<script setup>
  import { ref, onMounted } from 'vue'
  import { VDateInput } from 'vuetify/labs/VDateInput'
  import { useDate } from 'vuetify'
  import { useSystemStore } from '@/stores/system'
  import { useQuizZoneStore } from '@/stores/quizzone'
  import { useReportsStore } from '@/stores/reports'
  import { useExcelStore } from '@/stores/excel'

  const systemStore = useSystemStore()
  const quizZoneStore = useQuizZoneStore()
  const reportsStore = useReportsStore()
  const excelStore = useExcelStore()

  const quizList = ref([])
  const selectedQuiz = ref(null)
  const report = ref()

  const adapter = useDate()

  const showPreview = ref(false)
  const previewQuizId = ref(0)
  const previewClientId = ref(0)
  const previewLanguage = ref('English')
  const previewLanguages = ref([])
  const previewTitle = ref('')

  const loadQuiz = (quiz) => {
    quizZoneStore.getAdminMasterTitles(quiz.id).then(result => {
      if (result.success) {
        selectedQuiz.value = result.masterTitle
        previewTitle.value = quiz.title
       
        selectedQuiz.value.masterStartDate = adapter.date(selectedQuiz.value.masterStartDate)
        selectedQuiz.value.masterEndDate = adapter.date(selectedQuiz.value.masterEndDate)
      }
    }).catch(error => {
      console.log('getAdminMasterTitles', error)
    })
  }

  const saveMasterQuiz = () => {
    selectedQuiz.value.masterStartDate = adapter.setHours(selectedQuiz.value.masterStartDate, 2)
    selectedQuiz.value.masterEndDate = adapter.setHours(selectedQuiz.value.masterEndDate, 2)

    quizZoneStore.saveMasterQuiz(selectedQuiz.value).then(result => {
      if (result.success) {
        selectedQuiz.value = result.masterTitle
        
        quizList.value.forEach((q) => {
          if (q.id === selectedQuiz.value.id) {
            q.isActive = selectedQuiz.value.isActive
            selectedQuiz.value.translation.forEach((t) => {
              if (t.language === 'English') {
                q.title = t.title
                q.subtitle = t.subtitle
              }
            })
          }
        })

      }
    }).catch(error => {
      console.log('saveMasterQuiz', error)
    })  
  }

  const downloadFile = (id) => {

    report.value.Params.forEach((p) => {
      if (p.Name === 'QuizId') {
          p.Value = id
      }
    })

    reportsStore.getReportData(report.value, true, true).then(result => {
      if (result.success === true) {
        excelStore.downloadInMemoryExcelDocument(result.reportArray, 'QuizZoneStats').catch(error => {
            console.log('Download In Memory Excel Document', error)
        })                 
      }
    }).catch(error => {
        console.log(`Download File`, error)
    })
  }

  const getReport = () => {
    reportsStore.getReports(':QuizZone:').then(result => {
      if (result.success === true) {
        if (result.hasData) {
          const reports = JSON.parse(result.reportData);
          reports.forEach(element => {
            if (element.Params.length > 0) {
              element.Params = JSON.parse(element.Params) 
            }
          });

          report.value = reports.filter((x) => { return x.Id == 13 })[0]
        }
      }
    }).catch(error => {
        console.log(`get title`, error)
    })
  }

  const preview = (quiz) => {
    showPreview.value = true
    previewQuizId.value = quiz.id
    previewClientId.value = quiz.clientId

    quizZoneStore.getLanguages().then(result => {
      if (result.success) {
        previewLanguages.value = result.languages
        .filter(q => q.clientId === quiz.clientId)
        .map(q => q.language)
      }
    }).catch(error => {
      console.log('getLanguages', error)
    })
  }

  const loadPreview = () => {
    window.open(`https://quizzone.org/?clientId=${previewClientId.value}&preview=true&previewQuizId=${previewQuizId.value}&previewUser=${systemStore.userDetail.emailAddress}&previewLanguage=${previewLanguage.value}`, '_blank').focus()
  }

  onMounted(() => {
    quizZoneStore.getAdminQuizList().then(result => {
      if (result.success) {

        getReport()

        quizList.value = result.adminQuizList
      }
    }).catch(error => {
      console.log('getAdminQuizList', error)
    })
  })

</script>

<style scoped>
  .title-list {
    height: calc(100vh - 100px);
    overflow-y: auto;
  }
</style>
